import { api } from '../../services';
import Swal from "sweetalert2";


const gallery = {
  // namespaced: true,
  state: {
    current_media: {
        title:null,
        caption:"",
        file:{
            url:null,
            mime_type:null,
            size:null,
        },
        user_id:null
    },
    data: [],
    pagination: [],
    modals: {
      initial_filter: false,
      new_media: false,
      edit_media: false,
      confirm_delete_media: false,
      view_media: false
    },
    fields_search: {
      channel_id: 0,
      department_id: 0,
      user_id: 0,
      status_key: 0,
      start_date: "",
      expiration_date: "",
      lead_name: "",
      lead_phone: "",
    },
    model_fields_search: {
      channel_id: 0,
      department_id: 0,
      user_id: 0,
      status_key: 0,
      start_date: "",
      expiration_date: "",
      lead_name: "",
      lead_phone: "",
    },
    current_task: {},
    current_activity: {},
    actions_of_registers: [
      {
        name: 'Editar',
        icon: 'bx bxs-edit',
        action: 'edit',
      },
      {
        name: 'Excluir',
        icon: 'bx bxs-trash',
        action: 'delete',
      },
    ],
    departments_available: [],
    operators_available: [],
    new_task_trigger: {
      active: null,
      pipeline_id: 0,
      action: null,
      days_to_expire: 0,
      hour_expire: "00:00",
      scheduled_message: null,
      file_scheduled_message: null,
    }
  },
  mutations: {
    SET_GALLERY_DATA(state, payload) {
      state.data = payload;
    },
    SET_GALLERY_PAGINATION(state, payload) {
      state.pagination = payload
    },
  },
  getters: {

  },
  actions: {
    async getGallery(context, fields_search) {
      await api.get(`/gallery-medias`, { params: fields_search }).then(response => {
        context.commit('SET_GALLERY_DATA', response.data.data)
        context.commit('SET_GALLERY_PAGINATION', response.data)
      })
    },

    async createGalleryMedia(context, payload){
      await api.post('/gallery-medias', payload).then((response) => {
        this.dispatch('getGallery', {})
      })
    },

    async updateGalleryMedia(context, payload){
      await api.put(`/gallery-medias/${payload.id}`, payload).then((response) => {
        this.dispatch('getGallery', {});
      })
    },

    async deleteGalleryMedia(context, payload){
      await api.delete(`/gallery-medias/${payload.id}`, {}).then((response) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Mídia excluída`,
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {});
        this.dispatch('getGallery', {});
      })
      .catch(() => {});
    }
  }
}

export default gallery;
